import axios from 'axios';

import { apiClient } from '../apiClients';
import { Endpoints } from '../../network';

export const getAllOrdersList = async (page?: number) => {
  const response = await apiClient.get(
    `${Endpoints.getAllOrderHistory}?page=${page}`,
  );

  return response?.data;
};

export const getAllInAppOrdersList = async (page?: number) => {
  const response = await apiClient.get(
    `${Endpoints.getAllInAppOrderHistory}?page=${page}&perPage=${5}`,
  );

  return response?.data;
};

export const handleOrderCancel = async ({
  reason,
  orderId,
}: {
  reason: string;
  orderId: string;
}) => {
  const response = await apiClient.post(`${Endpoints.orderCancel}`, {
    order_id: orderId,
    reason: reason,
  });

  return response?.data;
};

export const syncOrder = async (orderId: string) => {
  const response = await apiClient.get(`${Endpoints.syncOrder}/${orderId}`);

  return response?.data;
};
export const syncOrderInApp = async (orderId: string) => {
  const response = await apiClient.get(
    `${Endpoints.syncOrderInApp}/${orderId}`,
  );

  return response?.data;
};

export const getOrdersDetails = async (id: string) => {
  const response = await apiClient.get(`${Endpoints.getOrderDetails}/${id}`);

  return response?.data;
};

export const getInAppOrdersDetails = async (id: string) => {
  const response = await apiClient.get(
    `${Endpoints.getInAppOrderDetails}/${id}`,
  );

  return response?.data;
};

export const getInvoice = async (id: string) => {
  const response = await apiClient.get(`${Endpoints.invoice}/${id}`, {
    responseType: 'blob',
  });

  return response?.data;
};

export const getOrderByHash = async (hash: string) => {
  const baseURL =
    process.env.NEXT_PUBLIC_API_URL || 'https://store.zebralearn.com';
  // Plain axios call with NO Bearer token as requested
  const response = await axios.get(
    `${baseURL}${Endpoints.orderByHash(hash)}`,
  );

  return response?.data;
};

export const getOrderInfoByHash = async (hash: string) => {
  const baseURL =
    process.env.NEXT_PUBLIC_API_URL || 'https://store.zebralearn.com';
  try {
    const response = await axios.get(
      `${baseURL}${Endpoints.orderInfoByHash(hash)}`,
    );
    return response?.data;
  } catch (err: any) {
    if (err?.response?.data) {
      return err.response.data;
    }
    throw err;
  }
};

export const verifyOrderPaymentByHash = async (
  hash: string,
  payload: {
    rzp_payment_id?: string;
    razorpay_payment_id?: string;
    razorpay_order_id?: string;
    razorpay_signature?: string;
    [key: string]: any;
  },
) => {
  const baseURL =
    process.env.NEXT_PUBLIC_API_URL || 'https://store.zebralearn.com';
  try {
    const response = await axios.post(
      `${baseURL}${Endpoints.orderPaymentVerifyByHash(hash)}`,
      payload,
    );
    return response?.data;
  } catch (err: any) {
    if (err?.response?.data) {
      return err.response.data;
    }
    throw err;
  }
};


